import React, { Component } from 'react'
import { MDBContainer, MDBRow, MDBCol, MDBBtn, MDBIcon, MDBInput, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter, MDBCarousel,
  MDBCarouselInner,MDBCarouselItem, MDBAlert, MDBTable, MDBTableBody, MDBTableHead  } from 'mdbreact';
import { MDBNavbar, MDBNavbarBrand, MDBNavbarNav, MDBNavbarToggler, MDBCollapse, MDBNavItem, MDBNavLink, MDBMask, MDBView, MDBCard, 
    MDBCardBody, MDBCardTitle, MDBCardText, MDBCardHeader, MDBDataTable, MDBFormInline } from 'mdbreact';
import { Form, Input, Button, Checkbox, message,Divider  } from 'antd';

import Axios from 'axios'

import Swal from 'sweetalert2'
import { api } from '../../api';


import LoadingOverlay from 'react-loading-overlay';
import Modalshowcitizen from './Modalshowcitizen';
import ReactExport from "react-data-export";
import NumberFormat from 'react-number-format';



const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;


export default class RoomReportmoneyday extends Component {
    

        constructor(props) {
            super(props);
            this.state = {
                value: '',
                Psaaword:'',
                modal: false,
                collapse: false,
                isWideEnough: false,

                code:'',
                bd:'',
                OLDID:'',
                BDATE:'',
                PNAME:'',
                NAME:'',
                FACULTY:'',

                authscore:[],
                authcount:'',
                studentcheck:[],
                work:[],
                roomreport:[],
                room2:[],
                room3:[],
                loading:false,
                date1:'',
                date2:'',
                summoney:[],
                summoneylist:[],
                manny:'0',
                moneylist:[],
                totallsum:[],
                mannyfulls:'',
                radio: 2,

            };
           
            this.handleSubmitstu = this.handleSubmitstu.bind(this);
            this.toggle = this.toggle.bind(this);
            this.onClick = this.onClick.bind(this);
             this.onClick1 = this.onClick1.bind(this);
            this.onTextChange = this.onTextChange.bind(this);
            this.getwork = this.getwork.bind(this);
            this.gotocheck = this.gotocheck.bind(this);
            this.senttomanufacture = this.senttomanufacture.bind(this);
            this.sentpdf = this.sentpdf.bind(this);
            this.getroom = this.getroom.bind(this);
            this.handleChange2 = this.handleChange2.bind(this);
            this.handleChange3 = this.handleChange3.bind(this);
            this.getreport = this.getreport.bind(this);
            this.getreportlist = this.getreportlist.bind(this);
            this.getreport2 = this.getreport2.bind(this);
            
          }

          //ตรวจสอบเงินจากวันเริ่ม
          getreport (){
           
            api.get('lkselectreportmoneydayfinish.php?date1='+this.state.date1)
            .then(res => {
             console.log(res);
             if (res.data.length != 0  ) {
                
                 this.setState({ summoney: res.data,
                                totallsum: res.data[0],
                                mannyfulls: res.data[0].Fulls,
                                chm: res.data[0].Fulls,
                                chm1: res.data[0].chm1,
                                chm2: res.data[0].chm2,
                                chm3: res.data[0].chm3,
                                revenue: res.data[0].revenue,
                                expenses: res.data[0].expenses,
                                totalkey: res.data[0].totalkey,
                                Fulls:res.data[0].Fulls,

                // numberroom: res.data[0].numberroom,
               }) }
            }) 

            api.get('lkselectreportmoneydayfinishlist.php?date1='+this.state.date1)
            .then(res => {
             console.log(res);
             if (res.data.length != 0  ) {
                
                 this.setState({ summoneylist: res.data,
               }) }else{
                Swal.fire({
                  title: 'ไม่พบข้อมูล',
                  icon: 'dangger',
                // showCancelButton: true,
                  confirmButtonText: 'ตกลง',
                // cancelButtonText: 'No, keep it'
                }).then((result) => {
                 
                 // window.location.href = '/'
                })
               }
            }) 
      
          }


           //ตรวจสอบเงินจากวันสิ้นสุด
           getreport2 (){
           
            api.get('lkselectreportmoneydayfinish2.php?date2='+this.state.date2)
            .then(res => {
             console.log(res);
             if (res.data.length != 0  ) {
                
                 this.setState({ summoney: res.data,
                                totallsum: res.data[0],
                                mannyfulls: res.data[0].Fulls,
                                chm: res.data[0].Fulls,
                                chm1: res.data[0].chm1,
                                chm2: res.data[0].chm2,
                                chm3: res.data[0].chm3,
                                revenue: res.data[0].revenue,
                                expenses: res.data[0].expenses,
                                totalkey: res.data[0].totalkey,
                                Fulls:res.data[0].Fulls,

                // numberroom: res.data[0].numberroom,
               }) }
            }) 

            api.get('lkselectreportmoneydayfinishlist2.php?date2='+this.state.date2)
            .then(res => {
             console.log(res);
             if (res.data.length != 0  ) {
                
                 this.setState({ summoneylist: res.data,
               }) }else{
                Swal.fire({
                  title: 'ไม่พบข้อมูล',
                  icon: 'dangger',
                // showCancelButton: true,
                  confirmButtonText: 'ตกลง',
                // cancelButtonText: 'No, keep it'
                }).then((result) => {
                 
                 // window.location.href = '/'
                })
               }
            }) 
      
          }

          getreportlist (){
            api.get('lkselectreportmoneylist.php?date1='+this.state.date1+'&date2='+this.state.date2)
            .then(res => {
            //  console.log(res);
            this.setState({ moneylist: res.data,
                // numberroom: res.data[0].numberroom,
                loading: false })
            }) 
          }


          

          onClick() {
            this.setState({
              collapse: !this.state.collapse,
            });
          }

          onClick1 = (nr) => () => {
            this.setState({
              radio: nr,
            });
          };
        

          toggle = () => {
            this.setState({
              modal: !this.state.modal
            });
          }

          onTextChange = (e) => {
            this.setState({ [e.target.name]: e.target.value })
         }

         handleChange2(event) {    this.setState({date1: event.target.value});  }
         handleChange3(event) {    this.setState({date2: event.target.value});  }

        //  getscore (){
        //     api.get('selectauthscore.php?id_authorities='+localStorage.getItem('id_authorities'))
        //     .then(res => {
        //     //  console.log(res);
        //     //  this.setState({ bankname: res.data, loading: false })
        //       this.setState({ authscore: res.data})
        //     }) 
        // }

        gotocheck(event) {

         //   console.log(event.target.value);
            const id = event.target.value;
            window.location.href = '/sorlalum/Checkstudentlist/'+id;

        }

        getwork (){
          this.setState({ loading:true})
        
            api.get('selectworkslforgraphic.php')
            .then(res => {
            //  console.log(res);
            //  this.setState({ bankname: res.data, loading: false })
              this.setState({ work: res.data, loading: false })
            }) 
        }

        getroom (){
            this.setState({ loading:true})
          
              api.get('selectreportstatus.php')
              .then(res => {
              //  console.log(res);
              //  this.setState({ bankname: res.data, loading: false })
                this.setState({ roomreport: res.data, loading: false })
              }) 

              api.get('selectroomstatus2.php')
              .then(res => {
              //  console.log(res);
              //  this.setState({ bankname: res.data, loading: false })
                this.setState({ room2: res.data, loading: false })
              }) 

              api.get('selectroomstatus3.php')
              .then(res => {
              //  console.log(res);
              //  this.setState({ bankname: res.data, loading: false })
                this.setState({ room3: res.data, loading: false })
              }) 
          }

        sentpdf(event) {
          const id = event.target.value;
          setTimeout(() => {
            window.open('https://lookmaenamping.com/sorlalumbackend/TCPDF-main/slfrom.php?id_workorder='+id+'', '_blank');
             // window.location.href ='http://localhost/tesspdf/TCPDF-main/tess.php?term='+this.state.term+'&idemp='+this.state.idemp 
           }, 0);
        }
       

        senttomanufacture(event) {
          //  console.log(event.target.value);
            const date = new Date().toISOString().slice(0, 10)
            const gg = event.target.value

            Swal.fire({
              title: 'ยืนยัน',
              text: "ส่งไปยังฝ่ายผลิต",
              icon: 'warning',
              showCancelButton: true,
              confirmButtonText: 'ตกลง',
             cancelButtonText: 'ยกเลิก'
            }).then((result) => {
                 if (result.isConfirmed) {

                    setTimeout(() => {
        
                        const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล
                        datafrm.append("id", gg);
                        datafrm.append("datesent", date);
                        api.post("updatesenttomanufacture.php",datafrm,{
                         headers: {
                                   'content-type': 'multipart/form-data'
                                  }
                                  })
                                          .then(res => {
                                             // console.warn(res);
                                             // console.log("response: ", res)
                                              if (res.status=== 200) {
            
                                            Swal.fire({
                                              title: 'ส่งไปยังฝ่ายผลิตสำเร็จ',
                                              icon: 'success',
                                            // showCancelButton: true,
                                              confirmButtonText: 'ตกลง',
                                            // cancelButtonText: 'No, keep it'
                                            }).then((result) => {
                                              this.getwork();
                                             // window.location.href = '/'
                                            })
                  
                                              }else{
                                              // window.location.href = '/'
                                              }
                  
                                          })
                  
                              }, 1000);
                  
                 // console.log('ok')
                  } else if (result.isDenied) {
                   // Swal.fire('Changes are not saved', '', 'info')
                  }
            })
         
           }
     


          handleSubmitstu() {
            // alert('A name was submitted: ' + this.state.value);
           setTimeout(() => {
        
              const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล
              datafrm.append("OLDID", this.state.OLDID);
              datafrm.append("BDATE", this.state.BDATE);
              datafrm.append("PNAME", this.state.PNAME);
              datafrm.append("NAME", this.state.NAME);
              datafrm.append("FACULTY", this.state.FACULTY);
        
              api.post("insertstudent.php",datafrm,{
                                    headers: {
                                        'content-type': 'multipart/form-data'
                                    }
                                })
        
                                .then(res => {
                                  //  console.warn(res);
                                   // console.log("response: ", res)
                                    if (res.status=== 200) {
  
                                  Swal.fire({
                                    title: 'ยืนยันลงทะเบียนสำเร็จ',
                                    icon: 'success',
                                  // showCancelButton: true,
                                    confirmButtonText: 'ตกลง',
                                  // cancelButtonText: 'No, keep it'
                                  }).then((result) => {
                                    this.toggle();  
                                    window.location.href = '/kprurun2021'
                                  })
        
                                    }else{
                                    // window.location.href = '/'
                                    }
        
                                })
        
                    }, 1000);
        
        //window.location.href = '/adminfaculty'
        //this.props.updateat();
        //this.getExpert()
        
          }

          componentDidMount (){
            if (localStorage.getItem('name') == null ) {
              //  window.location.href = 'https://lookmaenamping.com/sorlalum'
            } else {
  
            }
              this.getroom();
             // this.getstucount();
          }
        

 

    render() {
      console.log(this.state.date1)
      console.log(this.state.date2)
//      var d = new Date(date),
//      month = '' + (d.getMonth() + 1),
//      day = '' + d.getDate(),
//      year = d.getFullYear();
//const date = new Date().toISOString().slice(0, 10)
//  if (month.length < 2) 
//      month = '0' + month;
//  if (day.length < 2) 
//      day = '0' + day;

//            const date = year + '-' + month + '-' + day;
     //console.log(date)



     const data = {
        columns: [
          {
            label: 'ลำดับ',
            field: 'list',
            sort: 'list',
            width: 150
          },
          {
            label: 'ค้างคืน',
            field: 'numberroom',
            sort: 'numberroom',
            width: 270
          },
          {
            label: '2ชั่วโมง',
            field: 'price',
            sort: 'price',
            width: 200
          },
          {
            label: '3ชั่วโมง',
            field: 'start',
            sort: 'start',
            width: 100
          },
          {
            label: 'เช้าออกเย็น',
            field: 'end',
            sort: 'end',
            width: 100
          },
          {
            label: 'รับมัดจำกุญแจ',
            field: 'end1',
            sort: 'end1',
            width: 100
          },
          {
            label: 'คืนมัดจำกุญแจ',
            field: 'end2',
            sort: 'end2',
            width: 100
          },
          {
            label: 'มัดจำกุญแจสุทธิ',
            field: 'end3',
            sort: 'end3',
            width: 100
          },
          {
            label: 'รายรับห้องสุทธิ',
            field: 'end4',
            sort: 'end4',
            width: 100
          },
          {
            label: 'รายรับสุทธิ',
            field: 'end5',
            sort: 'end5',
            width: 100
          }

        ],

        rows: [...this.state.summoney.map((data, i) => (
          {
             list: <>{i+1}</>,
             numberroom: <>{data.chm}</>,
             price: <>{data.chm1}</>,
             start: <>{data.chm2}</>,
             end: <>{data.chm3 }</>,
             end1: <>{data.revenue }</>,
             end2: <>{data.expenses }</>,
             end3: <>{data.totalkey }</>,
             end4: <><NumberFormat value={data.totalall}  displayType={'text'} thousandSeparator={true}  /></>,
             end5: <><p className="font-weight-bold"><NumberFormat value={data.Fulls}  displayType={'text'} thousandSeparator={true}  /></p></>,
           
          }
         ))] 
    
    };

    const data2 = {
        columns: [
          {
            label: 'ลำดับ',
            field: 'list',
            sort: 'list',
            width: 150
          },
          {
            label: 'เลขที่ห้อง',
            field: 'numberroom',
            sort: 'numberroom',
            width: 270
          },
          {
            label: 'ราคา',
            field: 'price',
            sort: 'price',
            width: 200
          },
          {
            label: 'เวลาเข้า',
            field: 'start',
            sort: 'start',
            width: 100
          },
          {
            label: 'เวลาออก',
            field: 'end',
            sort: 'end',
            width: 100
          }

        ],

        rows: [...this.state.summoneylist.map((data, i) => (
          {
             list: <>{i+1}</>,
             numberroom: <>{data.numroomreport}</>,
             price: <>{data.sumpricereport}</>,
             start: <>{data.starttimereport}</>,
             end: <>{data.endtimereport }</>,
           
          }
         ))] 
    
    };

    const data3 = {
        columns: [
          {
            label: 'ลำดับ',
            field: 'list',
            sort: 'list',
            width: 150
          },
          {
            label: 'เลขที่ห้อง',
            field: 'numberroom',
            sort: 'numberroom',
            width: 270
          },
          {
            label: 'ราคา',
            field: 'price',
            sort: 'price',
            width: 200
          },
         
          {
            label: 'สถานะขณะนี้',
            field: 'statusroom',
            sort: 'statusroom',
            width: 100
          }
          

        ],

        rows: [...this.state.room3.map((data, i) => (
          {
             list: <>{i+1}</>,
             numberroom: <>{data.numberroom}</>,
             price: <>{data.price}</>,
             statusroom: <>ทำความสะอาด</>
            //  random: <h5 searchvalue={data.Curriculumopen_TEAM} >tourist <span className="badge badge-danger">narrow</span></h5>,

          }
         ))] 
    
    };

    const persons = <MDBDataTable
   
   searching ={false}
    searchLabel="ค้นหา รายการ"
    striped
    bordered
    small 
    entries={10}
   // entriesOptions={["10", "20"]}
    order={["age", "desc"]}
    data={data}
    entriesLabel="จำนวนที่แสดง "
    infoLabel= {["แสดง", "ถึง", "จากทั้งหมด", "รายการ"]}
    paginationLabel={["ย้อนกลับ", "ถัดไป"]}
    responsive 
    sortRows={['random']}
/>

const persons2 = <MDBDataTable
// searching ={true}
 searchLabel="ค้นหา รายการ"
 striped
 bordered
 small 
 entries={10}
// entriesOptions={["10", "20"]}
 order={["age", "desc"]}
 data={data2}
 entriesLabel="จำนวนที่แสดง "
 infoLabel= {["แสดง", "ถึง", "จากทั้งหมด", "รายการ"]}
 paginationLabel={["ย้อนกลับ", "ถัดไป"]}
 responsive 
 sortRows={['random']}
/>

const persons3 = <MDBDataTable
//searching ={true}
 searchLabel="ค้นหา รายการ"
 striped
 bordered
 small 
 entries={10}
// entriesOptions={["10", "20"]}
 order={["age", "desc"]}
 data={data3}
 entriesLabel="จำนวนที่แสดง "
 infoLabel= {["แสดง", "ถึง", "จากทั้งหมด", "รายการ"]}
 paginationLabel={["ย้อนกลับ", "ถัดไป"]}
 responsive 
 sortRows={['random']}
/>


const dataSet1 = [
  {
      name: "Johson",
      amount: 30000,
      sex: 'M',
      is_married: true
  },
  {
      name: "Monika",
      amount: 355000,
      sex: 'F',
      is_married: false
  },
  {
      name: "John",
      amount: 250000,
      sex: 'M',
      is_married: false
  },
  {
      name: "Josef",
      amount: 450500,
      sex: 'M',
      is_married: true
  }
];
      

        return (
       
          <LoadingOverlay
  active={this.state.loading}
  spinner
  text='Loading your data...'
  >
                <MDBContainer fluid >
                
  <h2 className="font-weight-bold  text-center">  รายงานการเงินรายวัน</h2>
<p className="text-right">   สวัสดี {localStorage.getItem('name')} : ผู้ใช้งาน</p>
      <MDBRow >
          {/* <div >
              <Modaladdwork/> 
          </div> */}
       
        <MDBCol md="12" className="d-flex justify-content-center">
        <MDBCard style={{ width: "100%", marginTop: "1rem" }}>
                    <MDBCardBody>
                    <MDBCardTitle className="text-center">  ข้อมูลการเงิน</MDBCardTitle>
                    <MDBRow className='d-flex justify-content-center'>
                    <div className="text-center">
                            <MDBFormInline className='text-center'>
                                <MDBInput
                                gap
                                onClick={this.onClick1(1)}
                                checked={this.state.radio === 1 ? true : false}
                                label="ค้นหาจากเวลาเริ่ม"
                                type="radio"
                                id="radio1"
                                containerClass="mr-5"
                                />
                                <MDBInput
                                gap
                                onClick={this.onClick1(2)}
                                checked={this.state.radio === 2 ? true : false}
                                label="ค้นหาจากเวลาสิ้นสุด"
                                type="radio"
                                id="radio2"
                                containerClass="mr-5"
                                />
                            
                            </MDBFormInline><br/>
           </div>
                    </MDBRow>
               <div className="text-center">
               <MDBRow className='text-center'>
               <MDBCol sm="2">
               </MDBCol>
                    {this.state.radio ===1?<>
                                        <MDBCol sm="8">
                                            <MDBInput type="date" label="วันที่เริ่ม" value={this.state.date1} onChange={this.handleChange2} outline />
                                        </MDBCol>

                    </>:<>
                                        <MDBCol sm="8">
                                            <MDBInput type="date" label="วันที่สิ้นสุด" value={this.state.date2} onChange={this.handleChange3} outline />
                                        </MDBCol>
                    </>}
                   
                   

                    <MDBCol sm="2">
                    </MDBCol>

                </MDBRow>
                {this.state.radio ===1?<>
                  <MDBBtn color="primary" onClick={this.getreport}>ค้นหาวันที่เริ่ม</MDBBtn>
                 </>:<> 
                 <MDBBtn color="primary" onClick={this.getreport2}>ค้นหาวันที่สิ้นสุด</MDBBtn>
                 </>}
                   
                
                </div>
                <br/>

                {/* {this.state.summoney.length != 0?<>
                    <MDBAlert className='text-center' color="warning" dismiss>
                        <strong>กรุณาเลือกช่วงที่ต้องการ</strong> 
                    </MDBAlert>
                </>:<>
                <ExcelFile filename={"รายงาน"+this.state.date1} element={ <MDBBtn >DOWNLOAD</MDBBtn> }>
                        <ExcelSheet data={this.state.totallsum} name="report">
                            <ExcelColumn label="ค้างคืน" value="chm"/>
                            <ExcelColumn label="2ชั่วโมง" value="1chm"/>
                            <ExcelColumn label="3ชั่วโมง" value="2chm"/>
                            <ExcelColumn label="เช้าออกเย็น" value="3chm"/>
                            <ExcelColumn label="มัดจำกุญแจ" value="revenue"/>
                            <ExcelColumn label="คืนมัดจำกุญแจ" value="expenses"/>
                            <ExcelColumn label="มัดจำกุญแจคงเหลือ" value="totalkey"/>
                            <ExcelColumn label="รายรับสุทธิ" value="Fulls"/>
                        </ExcelSheet>
                      
                    </ExcelFile>
                </>} */}



                    {this.state.date2 === '' && this.state.date1 === '' ? <>
                    <MDBAlert className='text-center' color="warning" dismiss>
                        <strong>กรุณาเลือกช่วงที่ต้องการ</strong> 
                    </MDBAlert>
                    </> : <>
                   
               
                    {this.state.summoney.length !== 0 ?<>
                      {this.state.date2 === '' && this.state.date1 === '' ? <>
                        <ExcelFile filename={"รายงานจากวันเริ่ม"+this.state.date1} element={ <MDBBtn >DOWNLOAD รายงานวันเริ่ม</MDBBtn> }>
                        <ExcelSheet data={this.state.summoney} name="total">
                            <ExcelColumn label="ค้างคืน" value="chm"/>
                            <ExcelColumn label="2ชั่วโมง" value="chm1"/>
                            <ExcelColumn label="3ชั่วโมง" value="chm2"/>
                            <ExcelColumn label="เช้าออกเย็น" value="chm3"/>
                            <ExcelColumn label="มัดจำกุญแจ" value="revenue"/>
                            <ExcelColumn label="คืนมัดจำกุญแจ" value="expenses"/>
                            <ExcelColumn label="มัดจำกุญแจคงเหลือ" value="totalkey"/>
                            <ExcelColumn label="รายรับสุทธิ" value="Fulls"/>
                        </ExcelSheet>

                        <ExcelSheet data={this.state.summoneylist} name="report">
                            <ExcelColumn label="เลขห้อง" value="numroomreport"/>
                            <ExcelColumn label="ราคา" value="sumpricereport"/>
                            <ExcelColumn label="เวลาเข้า" value="starttimereport"/>
                            <ExcelColumn label="เวลาออก" value="endtimereport"/>
                        </ExcelSheet>

                        
                      
                    </ExcelFile>
                      </> :<>
                      <ExcelFile filename={"รายงานจากวันสิ้นสุด"+this.state.date2} element={ <MDBBtn >DOWNLOAD รายงานวันสิ้นสุด</MDBBtn> }>
                        <ExcelSheet data={this.state.summoney} name="total">
                            <ExcelColumn label="ค้างคืน" value="chm"/>
                            <ExcelColumn label="2ชั่วโมง" value="chm1"/>
                            <ExcelColumn label="3ชั่วโมง" value="chm2"/>
                            <ExcelColumn label="เช้าออกเย็น" value="chm3"/>
                            <ExcelColumn label="มัดจำกุญแจ" value="revenue"/>
                            <ExcelColumn label="คืนมัดจำกุญแจ" value="expenses"/>
                            <ExcelColumn label="มัดจำกุญแจคงเหลือ" value="totalkey"/>
                            <ExcelColumn label="รายรับสุทธิ" value="Fulls"/>
                        </ExcelSheet>
                        <ExcelSheet data={this.state.summoneylist} name="report">
                            <ExcelColumn label="เลขห้อง" value="numroomreport"/>
                            <ExcelColumn label="ราคา" value="sumpricereport"/>
                            <ExcelColumn label="เวลาเข้า" value="starttimereport"/>
                            <ExcelColumn label="เวลาออก" value="endtimereport"/>
                        </ExcelSheet>
                      
                    </ExcelFile>
                      </>}
                  

                    <h1 className='text-right'> ยอดเงินรวม <span className="green-text"><NumberFormat value={this.state.Fulls}   displayType={'text'} thousandSeparator={true}  /></span> บาท</h1>
                     {persons}
                   
                     {persons2}
                    </>:<>
                    {/* <MDBAlert className='text-center' color="warning" dismiss>
                        <strong>ไม่มีข้อมูลที่เลือก</strong> 
                    </MDBAlert> */}
                    </>}              
                    </> }
      

                    <br/>

                    <div className='text-center'>
                        {/* <MDBBtn color="purple">ตรวจหลักฐาน</MDBBtn> */}
                    </div>
                     
                    </MDBCardBody>
       
         </MDBCard>
        </MDBCol>


      </MDBRow>
      {/* SELECT tb_score.oldid_score, tb_score.num_score, tb_score.file_score, tb_score.date_score, tb_score.status_score, tb_student.PNAME, tb_student.NAME
FROM tb_score
INNER JOIN tb_student ON tb_score.oldid_score=tb_student.OLDID */}

<br/>

  


                   
                    </MDBContainer>
                   </LoadingOverlay>  
     
        )
    }
}
